import React, { useState, useEffect, useRef } from "react";
import moment from "moment";
import { Progress } from "react-sweet-progress";
import "react-sweet-progress/lib/style.css";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { serverUrl } from "../Helpers/Config";
import { useDispatch, useSelector } from "react-redux";
import { getTeachingTask } from "../../redux/actions/teaching";
import { trimString, tokenAuthorize } from "../Helpers/Common";
import BoltIcon from "@mui/icons-material/Bolt";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import Swal from "sweetalert2";
import {
  ActiveIconColor,
  ButtonCommonTopGrey,
  ButtonCommonTopNew,
  Card,
  MenuItemCard,
  MenuItemDiv,
  TextGray,
} from "../../pages/Theme";
import { MdArchive, MdOutlineUnarchive } from "react-icons/md";
import { BsPin, BsPinFill } from "react-icons/bs";
import noprofile from "../../common/images-new/no-profile-pic.png";
import { Link } from "react-router-dom";
import PushPinIcon from "@mui/icons-material/PushPin";
import ArchiveOutlinedIcon from "@mui/icons-material/ArchiveOutlined";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { TbArchiveFilled } from "react-icons/tb";
import { TbArchiveOff } from "react-icons/tb";
import ArchiveIcon from "@mui/icons-material/Archive";
import UnarchiveIcon from "@mui/icons-material/Unarchive";
import { Tooltip } from "@mui/material";
import TimerOffIcon from "@mui/icons-material/TimerOff";

const noProfile = noprofile;

const CardAssignment = ({
  id,
  course,
  title,
  assigned,
  due,
  task,
  participants,
  submissions,
  notification,
  data,
}) => {
  const [dropdown, setDropdown] = useState(false);
  const popupRef = useRef();
  const history = useHistory();
  const dispatch = useDispatch();
  const isDefaultTheme = useSelector((state) => state.auth.isDefaultTheme);
  const userTheme = useSelector((state) => state.auth.theme);

  const isSuccess = useSelector((state) => state.teaching.isSuccess);
  const isSuccessRef = useRef(isSuccess);
  const [tutorGuid, setTutorGuid] = useState("");
  const [tutorProfile, setTutorProfile] = useState(null);
  const [tutorName, setTutorName] = useState("");

  const toggleDropdown = (e) => {
    e.preventDefault();
    setDropdown(!dropdown);
  };
  const changePin = (e) => {
    e.preventDefault();
    e.stopPropagation();
    let dataObj = { is_pinned: !data[1]?.is_pinned };
    axios
      .put(serverUrl.TeachingTasklistPin + `/${id}`, dataObj)
      .then((resp) => {
        if (resp.status === 200) {
          dispatch(getTeachingTask());
        }
      });
  };

  const changeArchive = (e) => {
    e.preventDefault();
    e.stopPropagation();
    let dataObj = { is_archived: !data[1].is_archived };
    axios
      .put(serverUrl.TeachingTasklistArchive + `/${id}`, dataObj)
      .then((resp) => {
        if (resp.status === 200) {
          dispatch(getTeachingTask());
        }
      });
  };

  useEffect(() => {
    const handleClick = (e) => {
      if (!popupRef.current.contains(e.target)) {
        setDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClick, false);
    return function cleanup() {
      document.removeEventListener("mousedown", handleClick, false);
    };
  });

  useEffect(() => {
    isSuccessRef.current = isSuccess;
  }, [isSuccess]);

  const handleDelete = () => {
    Swal.fire({
      title: "Confirmation",
      heightAuto: false,
      text: "Are you sure to delete this task list?",
      icon: "warning",
      showCancelButton: false,
      showDenyButton: true,
      confirmButtonText: "Confirm",
      denyButtonText: "Cancel",
      confirmButtonColor: "#3085d6",
      denyButtonColor: "#c1c1c1",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .delete(serverUrl.Teaching + `/${id}`)
          .then(() => {
            dispatch(getTeachingTask());
            Swal.fire({
              heightAuto: false,
              title: "Success",
              text: "Task list has been deleted",
              icon: "success",
            });
          })
          .catch((error) => {
            tokenAuthorize(error?.response?.status);
            Swal.close();
          });
      }
    });
  };

  const handleDuplicateTask = () => {
    Swal.fire({
      title: "Confirmation",
      heightAuto: false,
      text: "Are you sure to duplicate this task list?",
      icon: "warning",
      showCancelButton: false,
      showDenyButton: true,
      confirmButtonText: "Confirm",
      denyButtonText: "Cancel",
      confirmButtonColor: "#3085d6",
      denyButtonColor: "#c1c1c1",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .post(serverUrl.ActionDuplicateTask + `/${id}`)
          .then(() => {
            dispatch(getTeachingTask());
            Swal.fire({
              heightAuto: false,
              title: "Success",
              text: "Task list has been duplicated",
              icon: "success",
            });
          })
          .catch((error) => {
            tokenAuthorize(error?.response?.status);
            Swal.close();
          });
      }
    });
  };

  useEffect(() => {
    axios
      .get(serverUrl.Task + `/${id}`)
      .then((res) => {
        if (res.status === 200) {
          setTutorGuid(res.data?.tutor_guid);
          setTutorProfile(res.data?.tutor_profile);
          setTutorName(res.data?.tutor_name);
        }
      })
      .catch((error) => {
        tokenAuthorize(error?.response?.status);
      });
  }, [id]);

  // const value=500;
  const percentCompletion =
    participants && participants > 0
      ? Math.floor((data[1].all_completed / participants) * 100)
      : 0;
  const atelaseOne =
    participants && participants > 0
      ? Math.floor((data[1].at_least_one_completed / participants) * 100)
      : 0;

  const formatModernDate = (isoDate) => {
    const date = new Date(isoDate);
    return date.toLocaleDateString("en-GB", {
      year: "numeric",
      month: "short", // Jan, Feb, Mar, etc.
      day: "numeric", // 1, 2, 3...
    });
  };

  function getProgressPercent(startDate, endDate) {
    const start = new Date(startDate).getTime();
    const end = new Date(endDate).getTime();
    const today = new Date().getTime();

    if (isNaN(start) || isNaN(end)) return 0; // invalid dates
    if (end <= start) return 100; // avoid division by zero, treat as complete

    const total = end - start;
    const completed = today - start;

    const percent = (completed / total) * 100;

    return Math.min(100, Math.max(0, percent)); // clamp between 0–100
  }

  function getShortCode(name) {
    if (!name) return "";

    // Split by spaces
    const words = name.trim().split(/\s+/);

    if (words.length === 1) {
      // Single word → take first letter
      return words[0][0].toUpperCase();
    } else {
      // Multiple words → take first letter of first 2 words
      return (words[0][0] + words[1][0]).toUpperCase();
    }
  }
  const currentDate = new Date();
  return (
    <Card className="relative w-full flex flex-col border20px shadow-sm text-base text-black p-3 md:p-5 md:px-6  px-3 md:text-base">
      <div className="mb-2.5 flex items-center justify-between">
        <div className="flex items-center gap-1.5">
          {currentDate > new Date(due) && (
            <p className="text-sm lightColor flex items-center gap-1">
              <TimerOffIcon
                className="-ml-1 deleteColor"
                style={{ fontSize: "19px" }}
              />{" "}
              Expired
            </p>
          )}
          {currentDate < new Date(due) && (
            <>
              {participants > 0 && participants === submissions ? (
                <p className="text-sm lightColor flex items-center gap-1">
                  <CheckCircleIcon
                    className="-ml-1"
                    style={{
                      color:
                        userTheme == "" || userTheme == "default theme"
                          ? "#66D692"
                          : userTheme?.color2,
                    }}
                  />{" "}
                  Completed
                </p>
              ) : (
                <p className="text-sm flex lightColor items-center">
                  <BoltIcon className="blueColor -ml-1" /> Active
                </p>
              )}
            </>
          )}
        </div>
        <div className="flex items-center gap-1.5">
          {notification != null && notification > 0 && (
            <>
              <div
                className="circle-small"
                style={{
                  fontSize:
                    notification.toString().length > 2 ? "10px" : "14px",
                }}
              >
                {notification}
              </div>
            </>
          )}
          {data[1]?.is_archived ? (
            <Tooltip title={"Unarchive"} placement="top" arrow>
              <span>
                <TbArchiveOff
                  onClick={changeArchive}
                  style={{ fontSize: "25px" }}
                  className={`iconHover cursor-pointer secondaryIcon`}
                />
              </span>
            </Tooltip>
          ) : (
            <Tooltip title={"Archive"} placement="top" arrow>
              <span>
                <TbArchiveFilled
                  onClick={changeArchive}
                  style={{ fontSize: "24px" }}
                  className={`iconHover cursor-pointer secondaryIcon`}
                />
              </span>
            </Tooltip>
          )}
          <Tooltip
            title={data[1]?.is_pinned ? "Unpin" : "Pin"}
            placement="top"
            arrow
          >
            <span>
              <PushPinIcon
                onClick={changePin}
                style={{ fontSize: "24px" }}
                className={`iconHover -mr-1.5 ${
                  data[1]?.is_pinned ? "primaryIcon" : "secondaryIcon"
                }`}
              />
            </span>
          </Tooltip>
          <div
            ref={popupRef}
            onClick={toggleDropdown}
            className="cursor-pointer -mr-1"
          >
            <svg
              className="w-6 h-6 "
              fill="none"
              stroke="#C4C4C4"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z"
              />
            </svg>
            {dropdown && (
              <MenuItemCard
                className="absolute bg-white top-0 right-0 w-24 md:w-32 lg:w-36 mt-3 p-1 rounded-md filter 
                        drop-shadow transform -translate-x-4 z-50 translate-y-12 text-black"
              >
                <li className="md:pb-2 pl-2">
                  <MenuItemDiv
                    className="flex items-center md:mt-2 hover:opacity-70 cursor-pointer"
                    onClick={() => history.push(`/teaching/edit/${id}`)}
                  >
                    <p className="text-sm ">Edit</p>
                  </MenuItemDiv>
                  <MenuItemDiv
                    className="flex items-center md:mt-2 hover:opacity-70 cursor-pointer"
                    onClick={handleDuplicateTask}
                  >
                    <p className="text-sm ">Duplicate</p>
                  </MenuItemDiv>
                  <MenuItemDiv
                    className="flex items-center md:mt-2 hover:opacity-70 cursor-pointer"
                    onClick={handleDelete}
                  >
                    <p className="text-sm ">Delete</p>
                  </MenuItemDiv>
                </li>
              </MenuItemCard>
            )}
          </div>
        </div>
      </div>
      <div className="w-full mb-2.5">
        <p className=" blackColor font-semibold text-xl">{title}</p>
      </div>
      <div className="flex flex-col mb-2.5">
        <div className="w-full flex justify-between ">
          <span className="mr-1 text-md blackColor">Assigned on</span>
          <span className="text-md blackColor">Due on</span>
        </div>
        <div className="w-full my-2.5 px-3">
          <div className="relative w-full h-0.5 greyBackGroundColor rounded-full">
            {/* Progress fill */}
            <div
              className="absolute top-0 left-0 h-0.5 blueBackGroundColor"
              style={{
                width: `${getProgressPercent(assigned, due)}%`,
              }}
            />

            {/* Left end dot */}
            <div className="absolute -top-1.5 -left-3 -translate-y-1 z-10">
              <div className="w-3.5 h-3.5 rounded-full blueBackGroundColor flex items-center justify-center">
                <div className="w-2 h-2 rounded-full bg-white"></div>
              </div>
            </div>

            {/* Right end dot */}
            <div className="absolute -top-1.5 -right-3 -translate-y-1 z-10">
              <div className="w-3.5 h-3.5 rounded-full blueBackGroundColor flex items-center justify-center">
                <div className="w-2 h-2 rounded-full bg-white"></div>
              </div>
            </div>
          </div>
        </div>
        <div className="w-full flex justify-between">
          <span className="mr-1 text-sm greyColor">
            {formatModernDate(assigned)}
          </span>
          <span className="text-sm greyColor">{formatModernDate(due)}</span>
        </div>
      </div>
      <div className="w-full flex justify-between mb-1 blackColor">
        {/* <span className="">Task completed</span> */}
        <span className="">Completed all tasks</span>
        <span>{percentCompletion}%</span>
      </div>
      <div className="grid justify-items-center mb-3 taskPage">
        <Progress
          percent={percentCompletion}
          status="success"
          symbol=""
          theme={{
            success: {
              // symbol: percentCompletion + "%",
              color: isDefaultTheme == false ? userTheme?.color2 : "#66D692",
            },
          }}
        />
      </div>
      {/* <div className="flex flex-row mb-8">
        <div
          className="w-1/5 mr-2 flex flex-wrap content-center justify-center"
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          {tutorProfile !== null && (
            <Link to={"profile/" + tutorGuid} target="_blank">
              <img
                src={tutorProfile ? tutorProfile : noProfile}
                className="w-10 h-10 rounded-full object-cover"
              />
            </Link>
          )}
        </div>
        <div className="flex flex-col justify-center w-4/5 space-y-1 md:space-y-0">
          <div className="flex flex-col md:flex-row whitespace-nowrap md:text-sm xl:text-base">
            <TextGray className="mr-1">Assigned on</TextGray>
            <p className="font-semibold">
              {moment(assigned).format("DD/MM/YYYY")}
            </p>
          </div>
          <div className="flex flex-col md:flex-row whitespace-nowrap md:text-sm xl:text-base">
            <TextGray className="mr-1">Due on</TextGray>
            <p className="font-semibold">{moment(due).format("DD/MM/YYYY")}</p>
          </div>
        </div>
      </div> */}
      <span className="text-center greyColor text-md cursor-pointer mb-2">
        Completed at least 1 task: {atelaseOne}%
      </span>
      {(course || tutorName) && (
        <div className="flex items-center justify-between mt-auto">
          <div className="flex items-center gap-2 ">
            <div className="flex items-center">
              <ButtonCommonTopNew className="w-10 h-10 rounded-full flex items-center justify-center text-md font-semibold">
                {getShortCode(course || tutorName)}
              </ButtonCommonTopNew>
            </div>
            <div className="flex flex-col ">
              {course && (
                <span className="text-md font-semibold blackColor">
                  {course}
                </span>
              )}
              {tutorName && (
                <span className="text-sm blackColor flex gap-1.5">
                  <span className="greyColor font-normal"> by</span> {tutorName}
                </span>
              )}
            </div>
          </div>
          <ButtonCommonTopGrey className="w-10 h-10 rounded-full flex items-center justify-center text-md font-semibold">
            <KeyboardArrowRightIcon className="greyColor" />
          </ButtonCommonTopGrey>
        </div>
      )}
    </Card>
  );
};

export default CardAssignment;
